export default __webpack_public_path__ + "static/media/solesta-logo-white.9c084870.png";